/** Переключатель.
 *
 * Вынесен, потому что успел появиться дважды копипастой — и оба раза с
 * захардкоженным `#fff` вместо токена, вопреки правилу «в компонентах только
 * var()». Заодно подпись теперь обязательна параметром: раньше её задавали
 * `aria-label`, дублирующим видимый заголовок рядом.
 */
/* ПОЧЕМУ aria-disabled, А НЕ disabled.
 *
 * `disabled` вынимает кнопку из порядка обхода: фокус улетает в body ровно в тот
 * момент, когда человек ждёт ответа на своё нажатие. `aria-disabled` объявляет
 * то же состояние, не роняя фокус.
 *
 * От двойного нажатия disabled защищает не лучше: React ставит атрибут только
 * после коммита состояния, поэтому синхронная очередь нажатий проскакивает и
 * там, и там (замерено: три запроса в обоих случаях). Настоящая защита —
 * `if (busy) return;` в обработчике, и она есть везде, где нажатие что-то шлёт.
 */
export function Switch({ on, label, labelledBy, busy, onToggle }: {
  on: boolean;
  /** Своя подпись — когда рядом видимого текста нет. */
  label?: string;
  /** id видимой подписи рядом. Дублировать её в `aria-label` нельзя: тогда
   *  читалка произносит одно и то же дважды. */
  labelledBy?: string;
  busy?: boolean;
  onToggle: () => void;
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={on}
      aria-label={labelledBy ? undefined : label}
      aria-labelledby={labelledBy}
      aria-disabled={busy || undefined}
      onClick={() => { if (!busy) onToggle(); }}
      style={{
        width: 50, height: 30, borderRadius: "var(--r-pill)", border: "none", padding: 0,
        position: "relative", flexShrink: 0,
        cursor: busy ? "default" : "pointer",
        background: on ? "var(--switch-on)" : "var(--surface-3)",
      }}
    >
      <span
        aria-hidden="true"
        style={{
          position: "absolute", top: 2, left: on ? 22 : 2, width: 26, height: 26,
          borderRadius: "50%", background: "var(--text)",
          transition: "left var(--t-press) var(--ease)",
        }}
      />
    </button>
  );
}
